import type { AccessRequestCapabilityResponse } from '../types';

const PRODUCT = 'jira-software';

export const canUserRequestAccess = async (cloudId: string) => {
	const resource = `ari:cloud:${PRODUCT}::site/${cloudId}`;
	const params = new URLSearchParams({
		resource,
	});
	const response = await fetch(
		`/gateway/api/invitations/v1/access-requests/capabilities?${params.toString()}`,
		{
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
			},
		},
	);
	const capabilities = ((await response.json()) as unknown as AccessRequestCapabilityResponse)
		?.results[resource];

	return capabilities === 'DIRECT_ACCESS' || capabilities === 'REQUEST_ACCESS';
};
